import { Component, Input, OnInit } from '@angular/core';
import { UiServices } from 'src/app/services/ui-services';
import { MetricsBarComponent } from '../metrics-bar/metrics-bar.component';

@Component({
  selector: 'app-product-metric-card',
  templateUrl: './product-metric-card.component.html',
  styleUrls: ['./product-metric-card.component.scss'],
})
export class ProductMetricCardComponent implements OnInit {
  @Input() product: any;
  @Input() typeCard
  thumbnailImage: string;
  constructor(
    private uiSv: UiServices
  ) { }

  ngOnInit() {
    try{
      if(!this.product?.media){
        this.thumbnailImage = './assets/admin/defaultImage.png';
        return
      };
      this.thumbnailImage = this.product?.media[0]?.file;
    }catch(err){
      console.error(err);
    }
  }

  async seeMore(){
    this.uiSv.showModal(MetricsBarComponent, {product: this.product})
  }

}
